import React from "react";
import { Icon } from "react-icons-kit";
import { ic_format_list_bulleted } from "react-icons-kit/md/ic_format_list_bulleted";
import { ic_toggle_on } from "react-icons-kit/md/ic_toggle_on";
import { FieldType } from "./types";

// array / boolean use react-icons-kit (Material Design) glyphs for consistency with the
// rest of the portal. string / number / integer / object keep their bespoke "abc" / "1.0" /
// "123" / braces badges — the icon library has no equivalent in the installed version.
const LIBRARY_STYLES: Partial<Record<FieldType, { color: string; icon: object }>> = {
    array: { color: "#0056C7", icon: ic_format_list_bulleted },
    boolean: { color: "#E76826", icon: ic_toggle_on },
};

export const TypeIcon = ({ type, size = 24 }: { type: FieldType; size?: number }) => {
    const common = { width: size, height: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": true } as const;

    const libStyle = LIBRARY_STYLES[type];
    if (libStyle) {
        return (
            <span
                aria-hidden
                className="inline-flex items-center justify-center"
                style={{ width: size, height: size, borderRadius: size * 0.1667, backgroundColor: libStyle.color }}
            >
                <Icon icon={libStyle.icon} size={Math.round(size * 0.7)} style={{ color: "#fff", display: "flex" }} />
            </span>
        );
    }

    switch (type) {
        case "string":
            return (
                <svg {...common} fill="none">
                    <rect width="24" height="24" rx="4" fill="#00882E" />
                    <path d="M21 11H19.5V10.5H17.5V13.5H19.5V13H21V14C21 14.55 20.55 15 20 15H17C16.45 15 16 14.55 16 14V10C16 9.45 16.45 9 17 9H20C20.55 9 21 9.45 21 10V11ZM8 10V15H6.5V13.5H4.5V15H3V10C3 9.45 3.45 9 4 9H7C7.55 9 8 9.45 8 10ZM6.5 10.5H4.5V12H6.5V10.5ZM13.5 12C14.05 12 14.5 12.45 14.5 13V14C14.5 14.55 14.05 15 13.5 15H9.5V9H13.5C14.05 9 14.5 9.45 14.5 10V11C14.5 11.55 14.05 12 13.5 12ZM11 10.5V11.25H13V10.5H11ZM13 12.75H11V13.5H13V12.75Z" fill="white" />
                </svg>
            );
        case "object":
            return (
                <svg {...common} fill="none">
                    <rect width="24" height="24" rx="4" fill="#767676" />
                    <path d="M4 7V9C4 9.55 3.55 10 3 10H2V14H3C3.55 14 4 14.45 4 15V17C4 18.65 5.35 20 7 20H10V18H7C6.45 18 6 17.55 6 17V15C6 13.7 5.16 12.58 4 12.17V11.83C5.16 11.42 6 10.3 6 9V7C6 6.45 6.45 6 7 6H10V4H7C5.35 4 4 5.35 4 7Z" fill="white" />
                    <path d="M21 10C20.45 10 20 9.55 20 9V7C20 5.35 18.65 4 17 4H14V6H17C17.55 6 18 6.45 18 7V9C18 10.3 18.84 11.42 20 11.83V12.17C18.84 12.58 18 13.69 18 15V17C18 17.55 17.55 18 17 18H14V20H17C18.65 20 20 18.65 20 17V15C20 14.45 20.45 14 21 14H22V10H21Z" fill="white" />
                </svg>
            );
        case "integer":
            return (
                <svg {...common} fill="none">
                    <rect width="24" height="24" rx="4" fill="#0056C7" />
                    <path d="M7.25 15H5.75V10.5H4.25V9H7.25V15ZM13.75 13.5H10.75V12.5H12.75C13.3 12.5 13.75 12.05 13.75 11.5V10C13.75 9.45 13.3 9 12.75 9H9.25V10.5H12.25V11.5H10.25C9.7 11.5 9.25 11.95 9.25 12.5V15H13.75V13.5ZM19.75 14V10C19.75 9.45 19.3 9 18.75 9H15.25V10.5H18.25V11.5H16.25V12.5H18.25V13.5H15.25V15H18.75C19.3 15 19.75 14.55 19.75 14Z" fill="white" />
                </svg>
            );
        case "number":
            return (
                <svg {...common} fill="none">
                    <rect width="24" height="24" rx="4" fill="#0056C7" />
                    <text x="12" y="12" fill="#FFF" fontFamily="'Roboto Mono', monospace" fontSize="9" fontWeight="700" letterSpacing="-1.35" textAnchor="middle" dominantBaseline="central">1.0</text>
                </svg>
            );
        default:
            return null;
    }
};
